'use client';

import _slicedToArray from "/codebuild/output/src3207/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import 'react';
import 'react/jsx-runtime';
import { createOptionalContext } from '../../core/utils/create-optional-context/create-optional-context.mjs';
import '@mantine/hooks';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../core/Box/Box.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
var _createOptionalContex = createOptionalContext(),
  _createOptionalContex2 = _slicedToArray(_createOptionalContex, 2),
  ChipGroupProvider = _createOptionalContex2[0],
  useChipGroupContext = _createOptionalContex2[1];
export { ChipGroupProvider, useChipGroupContext };